import { cn } from '@/utils/utils';
import React from 'react';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    isPreventCopy?: boolean,
    isPreventCut?: boolean,
    isTypingOnlyNumber?: boolean
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
    ({ className, maxLength = 500, isPreventCopy, isPreventCut, isTypingOnlyNumber, onCopy, ...props }, ref) => {
        const onTypingOnlyNumber = (e, maxLength) => {
            if (
                e.key === 'Backspace' ||
                e.key === 'Delete' ||
                e.key === 'Tab' ||
                e.key === 'Escape' ||
                e.key === 'Enter' ||
                (e.key === 'a' && e.ctrlKey === true) ||
                (e.key === 'c' && e.ctrlKey === true) ||
                (e.key === 'v' && e.ctrlKey === true) ||
                (e.key === 'x' && e.ctrlKey === true) ||
                (e.key === 'ArrowLeft' || e.key === 'ArrowRight')
            ) {
                return;
            }

            if (e.target.value.length >= maxLength) {
                e.preventDefault();
                return;
            }

            if (!(e.key >= '0' && e.key <= '9')) {
                e.preventDefault();
            }
        };

        const onPreventCopy = (e) => {
            e.preventDefault();
        };

        const onPreventCut = (e) => {
            e.preventDefault();
        };

        return (
            <textarea
                maxLength={maxLength}
                className={cn(
                    'flex min-h-[80px] w-full text-[13px] text-input-1 placeholder:text-txtHolder placeholder:font-normal rounded-lg bg-bgInput px-3 py-4 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:border-active disabled:cursor-not-allowed disabled:opacity-50',
                    className
                )}
                ref={ref}
                placeholder='入力してください'
                onKeyDown={isTypingOnlyNumber ? e => onTypingOnlyNumber(e, maxLength) : undefined}
                onCopy={isPreventCopy ? onPreventCopy : onCopy}
                onCut={isPreventCut ? onPreventCut : undefined}
                {...props}
            />
        );
    }
);
TextArea.displayName = 'TextFeild';

export { TextArea };
